export default class Ui {
    constructor() {
        this.init();
    }

    init() {
        this.gnav();
        this.accordion();
        this.closeGnavOnLinkClick();
        this.copyUrl();
    }

    gnav() {
        const trigger = document.querySelector('.js-gnav_trigger');

        trigger.addEventListener('click', () => {
            if (document.body.getAttribute('data-gnavactive') === '0') {
                document.body.setAttribute('data-gnavactive', '1');
            } else {
                document.body.setAttribute('data-gnavactive', '0');
            }
        });
    }

    accordion() {
        const triggers = [...document.querySelectorAll('.js-acc_trigger')];

        const toggleAcc = (elm) => {
            const acc = elm.currentTarget.closest('.js-acc');
            const body = acc.querySelector('.js-acc_body');
            const bodyHeight = body.scrollHeight;

            const isOpen = acc.getAttribute('data-open') === '1';
            if (isOpen) {
                acc.setAttribute('data-open', '0');
                body.style.height = '0';
            } else {
                acc.setAttribute('data-open', '1');
                body.style.height = `${bodyHeight}px`;
            }
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', toggleAcc);
        });
    }

    closeGnavOnLinkClick() {
        if (!document.querySelector('body').classList.contains('post-type-archive-service')) return;

        const navLinks = [...document.querySelectorAll('.l-header__nav a')];
        navLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                if (event.currentTarget.href.includes('#')) {
                    const header = document.querySelector('.js-header');
                    header.setAttribute('data-active', '0');
                }
            });
        });
    }

    copyUrl() {
        const copyUrlBtn = document.querySelector('.js-copyurl');
        const delay = 3000;
        if (!copyUrlBtn) return;

        const handleCopyUrl = () => {
            const url = location.href;

            navigator.clipboard
                .writeText(url)
                .then(() => {
                    const copyTextSpan = copyUrlBtn.querySelector('.txt');
                    if (copyTextSpan) {
                        copyTextSpan.textContent = 'コピーしました';

                        setTimeout(() => {
                            copyTextSpan.textContent = 'リンクをコピー';
                        }, delay);
                    } else {
                        console.error('copy-text要素が見つかりません');
                    }
                })
                .catch((err) => {
                    console.error('クリップボードへの書き込みに失敗', err);
                });
        };

        copyUrlBtn.addEventListener('click', handleCopyUrl);
    }
}
